import React from 'react';
import {taxMoney} from './taxExport';

const totals = [
  ['totalRevenue', 'Revenue from paid orders'],
  ['totalSalesTax', 'Estimated sales tax'],
  ['totalFederalTax', 'Estimated federal tax'],
  ['totalTaxLiability', 'Total estimated tax liability'],
];

export default function TaxSummaryCards({meta}) {
  const excluded = meta.counts.excluded;
  return <>
    <div className="tax-center__summary">
      {totals.map(([key, label]) => <div className="tax-center__card" key={key}>
        <span>{label}</span><strong>{taxMoney(meta.summary[key])}</strong>
      </div>)}
    </div>
    <p className="tax-center__muted">{meta.counts.included} paid orders included. Excluded:
      {' '}{excluded.refunded} refunded, {excluded.canceled} canceled,
      {' '}{excluded.unsettled} unsettled, {excluded.unpaid} unpaid.</p>
    {meta.summary.truncated && <div className="warning" role="status">
      This report and its CSV cover only the newest 20,000 orders scanned.
      Choose a narrower date range for a complete report.
    </div>}
    {!meta.hasPayoutProfileState && <div className="warning">
      We don’t have your business state on file. <a href="/account/payments">
        Update your payout profile</a>. These US estimates use the buyer’s state.
    </div>}
  </>;
}
